export interface IMenuButton {
    position?: string;
}

export class MenuButton implements IMenuButton {
    constructor(public position: string) {}
}
  